/**
 * Constants for video file extensions that are supported in the application
 */
export const VIDEO_EXTENSIONS = ["mp4", "webm", "mkv", "mov", "avi"]

/**
 * Checks if a URL points to a video file based on its extension
 *
 * @param url - The URL to check
 * @returns boolean - True if the URL has a video extension, false otherwise
 */
export const isVideoUrl = (url?: string | null): boolean => {
  if (!url || typeof url !== "string") return false
  const extension = url.split(".").pop()?.toLowerCase()
  return extension ? VIDEO_EXTENSIONS.includes(extension) : false
}

/**
 * Checks if a media item from Umbraco is a video
 *
 * @param mediaItem - The media item object from Umbraco CMS
 * @returns boolean - True if the media item is a video, false otherwise
 */
export const isMediaItemVideo = (mediaItem?: {
  url?: string | null
}): boolean => {
  if (!mediaItem?.url) return false
  return isVideoUrl(mediaItem.url)
}
